import React from "react";
import {Pagination} from "zina-dogi-react";
import {HotTable} from "@handsontable/react";

const ServiceOrderTable = ({oet_ssoti, status, pagination, ...others}) => {
    const {oet, run} = others
    const data = getData(oet_ssoti, run, oet);
    const fathersIndex = data.filter(row => row.father).map(fatherRow => data.indexOf(fatherRow));
    const table_op = {
        width: "100%",
        height: 500,
        stretchH: "all",
        settings: {
            tableClassName: ["table", "table-bordered", "table-striped"],
            fillHandle: true,
            // disableVisualSelection: true,
            wordWrap: true,
            stretchH: "none",
            className: "htCenter htMiddle",
            colHeaders: getColHeaders(status),
            columns: getColumns(status),
            cells: (row, col) => {
                let cellProperties = {};
                if (fathersIndex.includes(row)) {
                    let ssot_item = data[row];
                    cellProperties.className = "rowFather htLeft htMiddle";
                    if (ssot_item.cancelled) {
                        cellProperties.className = "red-father htLeft htMiddle";
                    }
                }
                return cellProperties;
            },
            data
        }
    };
    return (
        <div>
            <HotTable {...others} {...table_op} />
            <div className="row">
                <div className="col-md-4">
                    <br/>
                    <span>Total {pagination.count}</span>
                </div>
                <div className="col-md-4">{pagination && <Pagination {...pagination} />}</div>
                <div className="col-md-4"></div>
            </div>
        </div>
    );
};

const getColHeaders = status => {
    let res = [
        "ZINA ID",
        "Functional location",
        "QC Line Item",
        "SI Code",
        "Item Description",
        "Original quantity",
        "Vendor Code",
        "Vendor Name",
        "Sales Office",
        "Delivery Date",
        "Service Start Date",
    ];
    const cpm = [
        "VOA #",
        "VOA line item #",
        "Unit Price",
        "Profit Centre",
        "SPO Header Text",
        "SVO text",
        "Account Indicator",
        "SVO number",
    ];
    // const omc = [
    //     "p20 sales_order",
    //     "Customer PO<br>line item number",
    //     "Customer PO<br>line quantity",
    //     "SAP service order",
    //     "SAP PR number",
    //     "SAP purchase order",
    //     "SVO maintenance<br>status"
    // ];
    if (status >= 4) {
        res = res.concat(cpm);
    }
    // if (status >= 5) {
    //     res = res.concat(omc);
    // }
    return res;
};

const getColumns = status => {
    let res = [
        {
            data: "id",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "wbs_or_contract",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "row_line_number_qc",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "material_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "description",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "quantity",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "vendor_code",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "vendor_name",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "sales_office",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "project_request_delivery_date",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "customer_request_delivery_date",
            className: "htLeft htMiddle",
            editor: false
        }
    ];
    const cpm = [
        {
            data: "voa_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_item_number",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "voa_item_net_price",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "profit_center",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "remarks",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "svo_text",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "acv_id",
            className: "htLeft htMiddle",
            editor: false
        },
        {
            data: "svo_number",
            className: "htLeft htMiddle",
            editor: false
        },
    ];
    // const omc = [
    //     {
    //         data: "p20_sales_order",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     },
    //     {
    //         data: "customer_po_line_item_number",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     },
    //     {
    //         data: "customer_po_line_quantity",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     },
    //     {
    //         data: "sap_service_order",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     },
    //     {
    //         data: "sap_pr_number",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     },
    //     {
    //         data: "sap_purchase_order",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     },
    //     {
    //         data: "svo_maintenance_status",
    //         className: "htLeft htMiddle",
    //         editor: false
    //     }
    // ];
    if (status >= 4) {
        res = res.concat(cpm);
    }
    // if (status >= 5) {
    //     res = res.concat(omc);
    // }

    return res;
};

const getData = (oet_ssoti, run, oet) => {
    let res = [];
    if (oet_ssoti && oet_ssoti.length > 0) {
        oet_ssoti.map(item => {
            const omc = item.item_omc;
            if (omc) {
                omc.omc_id = omc.id;
                delete omc.id;
            }
            const father = {
                ...item,
                material_code: item.cost_package.code,
                voa_case: item.voa_case ? item.voa_case.name : null,
                description: item.cost_package.name,
                sap_wbs_region_description: item.site ? item.site.sap_wbs_region_description : null,
                customer_site_code: item.site ? item.site.customer_site_code : null,
                ...(omc ? omc : {}),
                synergy: item.synergy !== null ? (item.synergy ? "Synergy Partner" : "Non Synergy Partner") : null,
                father: true,
                wbs_or_contract: oet.quantity_contract_number ? oet.quantity_contract_number : item.sap_wbs_zone_description,
                sales_office: oet.sales_office,
                profit_center: run.profit_center,
            };
            delete father.site_service_order_template_item;
            // res.push(father);
            if (item.ssot_items_cpm && item.ssot_items_cpm.length > 0) {
                item.ssot_items_cpm.map(ssot_item_cpm => {
                    ssot_item_cpm.cmp_id = ssot_item_cpm.id;
                    delete ssot_item_cpm.cmp_id;
                    const obj = {
                        ...father,
                        father: false,
                        ...ssot_item_cpm,
                        row_line_number_qc: father.row_line_number_qc,
                        material_code: ssot_item_cpm.cost_package_sales_item.sales_item_code,
                        description: ssot_item_cpm.cost_package_sales_item.description,
                        svo_text: ssot_item_cpm.svo_text,
                        svo_number: ssot_item_cpm.svo_number,
                        quantity: item.quantity
                    };
                    res.push(obj);
                    return [];
                });
            }
            return [];
        });
    }
    res = res.length === 0 ? [{}] : res;
    return res;
};

export default ServiceOrderTable;
